import React from 'react';
import { Constants } from '../../../../../constants/constants';
import { UpsellPanelSteps } from '../../../../../constants/upsellPanelEnumsAndConstants';

export const Step8ExistingUserLoginContent = () => {
    const model = useUpsellWidgetModel();
    const { currentStep } = useUpsellWidgetContainer();
    if (currentStep !== UpsellPanelSteps.Step8ExistingUserLogin) {
        return null;
    }
    return (
        <div>
            {
                model.existingSubscriberText ?
                    <div className="col-12 col-xs-12">
                        <p className="m-l-md m-b-0 user-exists-msg font-19">{model.existingSubscriberText}</p>
                        <p className="m-l-md user-exists-action font-19">{model.existingSubscriberParagraph}</p>
                    </div>
                    : <div className="col-12 col-xs-12">
                        <h2 className="lead font-19">The email address you entered is registered with {Constants.INVESTSMART}.</h2>
                        <p className="font-19">Login or to reset your password, select Forgotten password</p>
                    </div>
            }
        </div>
    );
};
